import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50/90 backdrop-blur-sm text-foreground-800 rounded-full text-sm font-medium font-label hover:bg-background-50 transition-colors cursor-pointer shadow-sm whitespace-nowrap"
      >
        Browse Categories
        <span className="w-4 h-4 flex items-center justify-center">
          {isOpen ? (
            <i className="ri-arrow-up-s-line text-sm"></i>
          ) : (
            <i className="ri-arrow-down-s-line text-sm"></i>
          )}
        </span>
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 left-0 w-56 bg-background-50 rounded-xl shadow-lg border border-background-200 py-2 z-40 max-h-80 overflow-y-auto">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors font-body cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              {cat.name}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}